export const isProgrammeOptionSelectionPending = (applicant) =>
  applicant?.programme?.enableOptionSelection === true;

export const getProgrammeOptionChoices = (programmes, currentProgramme, programmeTypeId) => {
  if (!Array.isArray(programmes) || !currentProgramme || programmeTypeId == null) return [];

  return programmes.filter((programme) =>
    programme != null &&
    programme.availableOnline === true &&
    programme.enableOptionSelection === false &&
    String(programme.id) !== String(currentProgramme.id) &&
    (programme.programmeType?.id ?? programme.programmeTypeId) != null &&
    String(programme.programmeType?.id ?? programme.programmeTypeId) === String(programmeTypeId) &&
    (
      currentProgramme.department?.id == null ||
      programme.department?.id == null ||
      String(programme.department.id) === String(currentProgramme.department.id)
    )
  );
};
